<template>
  <div style="max-width: 700px">
    <div class="flex-grow-1">
      <manage-profile-my-profile v-if="manageTabIndex == 'profile-myprofile'"></manage-profile-my-profile>

      <manage-profile-notifications v-if="manageTabIndex == 'profile-notifications'"></manage-profile-notifications>

      <manage-profile-appearance v-if="manageTabIndex == 'profile-appearance'"></manage-profile-appearance>

      <manage-profile-integrations v-if="manageTabIndex == 'profile-integrations'"></manage-profile-integrations>
    </div>
  </div>
</template>

<script>
  import ManageProfileMyProfile from './ManageProfileMyProfile.vue';
  import ManageProfileNotifications from './ManageProfileNotifications.vue';
  import ManageProfileAppearance from './ManageProfileAppearance.vue';
  import ManageProfileIntegrations from './ManageProfileIntegrations.vue';
  import useManageStore from '@/stores/manage';

  export default {
    components: {
      ManageProfileMyProfile,
      ManageProfileNotifications,
      ManageProfileAppearance,
      ManageProfileIntegrations,
    },
    data() {
      return {
        manageStore: useManageStore(),
      };
    },
    computed: {
      manageTabIndex: {
        get() {
          return this.manageStore.manageTabIndex;
        },
        set(newVal) {
          this.manageStore.manageTabIndex = newVal;
        },
      },
    },
  };
</script>
